import { Outlet } from './types';
import { Link } from 'react-router-dom';
import { Box, Card } from '@ff-it/ui';

export function OutletGrid({ outlets }: { outlets: (Outlet & { num_products?: number })[] }) {
  return (
    <div
      style={{
        display: 'grid',
        gap: '20px',
        gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
      }}
    >
      {outlets.map((outlet: Outlet & { num_products?: number }) => (
        <Card
          key={outlet.id}
          header={
            <Box display="flex">
              {outlet.name}{' '}
              {outlet.category && (
                <Box as="span" color="gray500" fontWeight="regular" mx="2">
                  {outlet.category.name}
                </Box>
              )}
              <Box marginLeft="auto" fontWeight="regular">
                {outlet.type ? outlet.type : 'Any'}
              </Box>
            </Box>
          }
        >
          {outlet.num_products !== undefined && (
            <Box>
              <Link to={`${outlet.id}/products`}>
                <strong>{outlet.num_products}</strong> products
              </Link>
            </Box>
          )}
        </Card>
      ))}
    </div>
  );
}
